import { FC, lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import GenericLoader from "@components/GenericLoader";

const SignUp = lazy(() => import("./signup"));
const Login = lazy(() => import("./signin"));
const ForgotPassword = lazy(() => import("./forgotPassword"));
const VehicleInfo = lazy(() => import("./vehicleInfo"));
const CustomerInfo1 = lazy(() => import("./customerInfo"));
const CustomerInfo2 = lazy(() => import("./customerInfo/page2"));
const Summary = lazy(() => import("./summary"));
const Offer = lazy(() => import("./offer"));
const Offered = lazy(() => import("./offered"));
const OfferStatus = lazy(() => import("./offer-status"));
const Admin = lazy(() => import("./admin"));
const Values = lazy(() => import("./values"));

const Routes: FC = () => {
  return (
    <Suspense fallback={<GenericLoader invert />}>
      <Switch>
        <Route path="/signup" component={SignUp} exact />
        <Route path="/signin" component={Login} exact />
        <Route path="/forgot-password" component={ForgotPassword} exact />
        <Route path="/vehicle-info" component={VehicleInfo} exact />
        <Route path="/customer-info-one/:vehicleId" component={CustomerInfo1} exact />
        <Route path="/customer-info-two/:vehicleId/:customerId" component={CustomerInfo2} exact />
        <Route path="/summary/:vehicleId/:customerId" component={Summary} exact />
        <Route path="/offer/:vehicleId/:customerId" component={Offer} exact />
        <Route path="/offered" component={Offered} exact />
        <Route path="/oa/:token/:decision" component={OfferStatus} exact />
        <Route path="/admin" component={Admin} exact />
        <Route path="/values/:token" component={Values} exact />
        <Route path="/:vehicleId/:customerId" component={Offer} exact />
        <Redirect to="/signin" />
      </Switch>
    </Suspense>
  );
};

export default Routes;
